/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForAgencyOutput
 */
export interface CriteriaForAgencyOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForAgencyOutput
     */
    agencyEffective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForAgencyOutput
     */
    agencyGroupEffective?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForAgencyOutput
     */
    agencyGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForAgencyOutput
     */
    agencyGroupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForAgencyOutput
     */
    agencyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForAgencyOutput
     */
    agencyName?: string | null;
}

export function CriteriaForAgencyOutputFromJSON(json: any): CriteriaForAgencyOutput {
    return CriteriaForAgencyOutputFromJSONTyped(json, false);
}

export function CriteriaForAgencyOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForAgencyOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencyEffective': !exists(json, 'agencyEffective') ? undefined : json['agencyEffective'],
        'agencyGroupEffective': !exists(json, 'agencyGroupEffective') ? undefined : json['agencyGroupEffective'],
        'agencyGroupId': !exists(json, 'agencyGroupId') ? undefined : json['agencyGroupId'],
        'agencyGroupName': !exists(json, 'agencyGroupName') ? undefined : json['agencyGroupName'],
        'agencyId': !exists(json, 'agencyId') ? undefined : json['agencyId'],
        'agencyName': !exists(json, 'agencyName') ? undefined : json['agencyName'],
    };
}

export function CriteriaForAgencyOutputToJSON(value?: CriteriaForAgencyOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencyEffective': value.agencyEffective,
        'agencyGroupEffective': value.agencyGroupEffective,
        'agencyGroupId': value.agencyGroupId,
        'agencyGroupName': value.agencyGroupName,
        'agencyId': value.agencyId,
        'agencyName': value.agencyName,
    };
}


